










import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator';
import { LiteratureAdviceService, LiteratureAdviceViewModel } from '../../api/literatureAdvice';
@Component({})
export default class LiteratureAdvice extends Vue {
  @Prop() private literatureId?: string;
  private service: LiteratureAdviceService = new LiteratureAdviceService();
  private data: LiteratureAdviceViewModel = this.service.NewModel;
  private rules = {
    content: [{required: true, message: '请输入反馈内容', trigger: 'blur'}],
  };
  @Emit('OnSave')
  private OnSave(val: any) {
    return val;
  }

  private Save() {
    const validate = this.$refs['edit-form'] as any;
    validate.validate((valid: any) => {
      if (valid) {
        this.data.literatureID = this.literatureId!;
        this.service.Create(this.data).then((response: any) => {
          this.$message.success('保存成功');
          this.OnSave(this.data);
        });
      }
    });
  }
}
